import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';

const useNavigationHistory = () => {
    const location = useLocation();
    const prevLocationRef = useRef();
    const parentofPrevLocationRef = useRef();

    useEffect(() => {
        parentofPrevLocationRef.current = prevLocationRef.current;
        prevLocationRef.current = location;
    }, [location]);

    return {
        previousLocation: prevLocationRef.current,
        parentofPrevLocation: parentofPrevLocationRef.current
    };
};

export default useNavigationHistory;